import React, { useState, useEffect, useContext } from "react";
import { Container, Col, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import bulletPoint from "../../../images/bullet point.svg";
import renderHTML from 'react-render-html';
import URLstateContext from "../../../provider/CommonContext";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
import animation from '../../../images/jm-animation.gif';


function ProductFaq(props) {
  const [data, setData] = useState(false);
  const { BaseURL } = useContext(URLstateContext);
  const [loadingshow, setloadingshow] = useState(false);
  let getSchemeCode = props.SchemeCode;

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetFundFAQ", {
      IVSchemeCode: getSchemeCode,
    }).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        setloadingshow(false);
      }
      else {
        setloadingshow(false);
      }
    });

    //  GetPostMethodData(BaseURL + "GetRelatedFunds", {
    //   IVSchemeCode: getFundCode,  
    // }).then((data)=>{
      
    //   setloadingshow(false);
    //   if(data.data != null && data.data.length >0){
    //     setData(DecryptAESdata(data.data));
    //     setloadingshow(false)
    //   }
    //   else{
    //     setloadingshow(false)
    //   }
      
    // })
    
  }, [BaseURL]);


  // useEffect(()=>{
  //   setloadingshow(true);
  //   GetPostMethodData(BaseURL + "GetRelatedFunds", {
  //     fundcode : getFundCode,
  //   }).then((data)=>{
  //     setloadingshow(false);
  //     if(data.data != null && data.data.length >0){
  //       setData(DecryptAESdata(data.data));
  //       setloadingshow(false)
  //     }
  //     else{
  //       setloadingshow(false)
  //     }
  //   })
  // }, [BaseURL])


  return (
    <>
      <section className="product_faq-sc" id="faq">
        <div className="section-heading faqSection">
          FAQ's
        </div>
        {/* {(data === false) ? <h6 className="errorMsg">No Data Found !!!</h6> : ''} */}

        <Container>
          <Row>
            <Col>
              {loadingshow ? (
                <div className="textcentervertex HomeLoader" role="status" aria-live="polite" aria-busy="true">
                  <img src={animation} alt="" aria-hidden="true" />
                  <div className="model_popup">Please Wait...</div>
                </div>
              ) : (
                <div>
                  {(data === false) ? (
                    <h5 className="errormsgComNew" role="alert">No Data Available</h5>
                  ) : (
                    <>
                      {data &&
                        data.map(
                          ({ heading, description }) => (
                            <Accordion className="accordionFinQ accordionProduct">
                              <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                  <img className="bulletFaq" src={bulletPoint} alt="bulletPoint"/>
                                  {heading}
                                </Accordion.Header>
                                <Accordion.Body className="textjustify">
                                  {renderHTML(description)}
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          ))}
                    </>
                  )}
                </div>
              )}
            </Col>
          </Row>
        </Container>
        {/* {loadingshow ? <div className="textcentervertex">
          <img src={animation} alt="Loading" />
          <div className="model_popup">Please Wait...</div>
        </div> : ""
        } */}

      </section>


  
       {/* {selectedFundName && (
        <section className="product_fund-details-sc" id="funds-details">
          <div className="section-heading">
            Related Funds for {selectedFund.name}
          </div>

          {loading ? (
            <p>Loading related funds...</p>
          ) : (
            <div className="main-related-fund-cnt">
              {relatedFunds.length > 0 ? (
                relatedFunds.map((fundname, Related_fundname, Related_link) => (
                  <div className="related-fund-box" key={index}>
                    <a href={fund.Related_link} target="_blank">
                      {fund.Related_fundname}
                    </a>
                  </div>
                ))
              ) : (
                <p>No related funds Data.</p>
              )}
            </div>
          )}
        </section>
      )} */}
    </>
  )
}

export default ProductFaq